var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionsFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.75V2.75C15.75 2.21957 15.5393 1.71086 15.1642 1.33579C14.7891 0.960714 14.2804 0.75 13.75 0.75H0.75",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 18.75H18.75C19.2804 18.75 19.7891 18.5393 20.1642 18.1642C20.5393 17.7891 20.75 17.2804 20.75 16.75V15.75C20.75 15.4848 20.6446 15.2304 20.4571 15.0429C20.2696 14.8554 20.0152 14.75 19.75 14.75H9.75C9.48478 14.75 9.23043 14.8554 9.04289 15.0429C8.85536 15.2304 8.75 15.4848 8.75 15.75V16.75C8.75 17.2804 8.53929 17.7891 8.16421 18.1642C7.78914 18.5393 7.28043 18.75 6.75 18.75ZM6.75 18.75C6.21957 18.75 5.71086 18.5393 5.33579 18.1642C4.96071 17.7891 4.75 17.2804 4.75 16.75V2.75C4.75 2.21957 4.53929 1.71086 4.16421 1.33579C3.78914 0.960714 3.28043 0.75 2.75 0.75C2.21957 0.75 1.71086 0.960714 1.33579 1.33579C0.960714 1.71086 0.75 2.21957 0.75 2.75V4.75C0.75 5.01522 0.855357 5.26957 1.04289 5.45711C1.23043 5.64464 1.48478 5.75 1.75 5.75H4.75",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.75H10.75",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.75H10.75",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsFigma);
export default __webpack_public_path__ + "static/media/transactions-figma.310d2c2e988fbd05b8061c7a68038673.svg";
export { ForwardRef as ReactComponent };